<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariIndex'
}
</script>
